import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import { superAxiosRequest } from 'axiosApi'
import CheckReportTable from './CheckReportTable/CheckReportTable'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { splitNumberDigits } from 'helpers/math'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import { useHistory } from 'react-router-dom'

const AverageCheckReport = () => {
  const [groupCatalog, setGroupCatalog] = useState({})
  const [checkTableData, setCheckTableData] = useState()
  const [pageState, setPageState] = useState({
    firstLoad: true,
    isLoading: false,
  })
  const [online, setOnline] = useState(2)
  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  // useEffect(() => {
  //     let isMounted = true;
  //     setPageState(prevState => ({...prevState, isLoading: true}));
  //     const apiConf = {
  //         method: 'get',
  //         link: 'groups/groups_catalog',
  //     }
  //     superAxiosRequest(apiConf).then(res => {
  //         setPageState({...pageState, isLoading: false})
  //         setGroupCatalog(res.data)
  //     })
  //     return () => { isMounted = false; };
  //
  // }, [])
  //
  // useEffect(() => {
  //     return AsideFilterStore.unmountFilter
  // }, []);

  useEffect(() => {
    let isMounted = true
    setPageState((pageState) => ({ ...pageState, isLoading: true }))

    const apiConf = {
      method: 'get',
      link: 'groups/groups_catalog',
    }

    superAxiosRequest(apiConf)
      .then((res) => {
        if (isMounted) {
          setPageState((pageState) => ({ ...pageState, isLoading: false }))
          setGroupCatalog(res.data)
        }
      })
      .catch(() => {})

    return () => {
      isMounted = false
    }
  }, [])

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: groupCatalog.locations?.items,
      sort_key: 'name',
      nameState: 'location',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
      isRequired: true,
    },
    {
      type: 'select-multi',
      label: 'Тип группы',
      placeholder: 'Тип группы',
      values: groupCatalog.types?.items,
      sort_key: 'name',
      nameState: 'group_type',
    },
    {
      type: 'select-multi',
      label: 'Уровень курса',
      placeholder: 'Уровень курса',
      values: groupCatalog.course_levels?.items,
      sort_key: 'name',
      nameState: 'course_level',
    },
    {
      type: 'select-multi',
      label: 'Уровень группы',
      placeholder: 'Уровень группы',
      values: groupCatalog.skill_levels?.items,
      sort_key: 'name',
      nameState: 'skill_level',
    },

    {
      type: 'type_selector',
      nameState: 'online',
      label: 'Формат',
      values: [
        { id: 2, name: 'Все группы' },
        { id: 1, name: 'Онлайн' },
        { id: 0, name: 'Офлайн' },
      ],
    },
  ]

  const sendRequest = () => {
    const params = {
      ...filter,
    }

    if (groupCatalog.locations) {
      setPageState({ isLoading: true })

      if (params.skill_level && params.skill_level.length > 0)
        params.skill_level = `[${params.skill_level.map((item) => item)}]`
      if (params.course_level && params.course_level.length > 0)
        params.course_level = `[${params.course_level.map((item) => item)}]`
      if (params.location && params.location.length > 0)
        params.location = `[${params.location.map((item) => item)}]`
      if (params.group_type && params.group_type.length > 0)
        params.group_type = `[${params.group_type.map((item) => item)}]`

      let apiConf = {
        method: 'get',
        link: 'progress_report/average_check_report',
        params: params,
      }

      superAxiosRequest(apiConf).then((res) => {
        if (res.data.result.locations) {
          let newData = {
            ...res.data.result,
            locations: [],
          }
          let resultAverageCredit = 0
          let resultAverageDebit = 0
          res.data.result.locations.forEach((item) => {
            if (item.location_id) {
              let location = {
                title: groupCatalog.locations.items.find(
                  (loc) => loc.id === item.location_id,
                ).name,
                data: [],
              }
              item.skill_levels.forEach((skill_lvl) => {
                if (skill_lvl.skill_level_id) {
                  location.data.push({
                    ...skill_lvl,
                    title: res.data.skill_levels.find(
                      (find_sk_lvl) =>
                        find_sk_lvl.id === skill_lvl.skill_level_id,
                    ).name,
                  })
                  resultAverageCredit =
                    resultAverageCredit + skill_lvl.aver_credit
                  resultAverageDebit = resultAverageDebit + skill_lvl.aver_debit
                }
              })
              newData.locations.push(location)
            }
          })
          if (params.online || params.online === 0) setOnline(params.online)
          newData.resultAverageCredit = resultAverageCredit
          newData.resultAverageDebit = resultAverageDebit
          setCheckTableData(newData)
        } else setCheckTableData()
        setPageState({ isLoading: false })
      })
    }
  }

  useEffect(() => {
    sendRequest()
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/average_check_report') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Школа',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Тип программы ',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Приход студентов',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Средний приход',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Списание со студентов',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Среднее списание',
          ...ExcelRowsParams.headerRowParam,
        },
      ]
      let footerRows = [
        [
          {
            v: `Итого (клиентов ${data.clients_amount})`,
            ...ExcelRowsParams.footerRowParams.firstCell,
          },
          {
            v: '',
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((data.all_debit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((checkTableData.resultAverageCredit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((data.all_credit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((checkTableData.resultAverageDebit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
        ],
        [
          {
            v: 'Средние показатели',
            ...ExcelRowsParams.footerRowParams.firstCell,
          },
          {
            v: '',
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((data.average_debit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: ``,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: `${splitNumberDigits((data.average_credit / 100).toFixed(2))}`,
            ...ExcelRowsParams.footerRowParams.cell,
          },
          {
            v: ``,
            ...ExcelRowsParams.footerRowParams.cell,
          },
        ],
      ]
      let tableData = []

      let merges = []
      let wscols = [
        { wch: 30 },
        { wch: 20 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ]

      let currentRow = 1
      data.locations.forEach((location) => {
        if (location.data.length > 1) {
          merges.push({
            s: { r: currentRow, c: 0 },
            e: { r: currentRow + location.data.length - 1, c: 0 },
          })
        }
        location.data.forEach((skill_level) => {
          currentRow = currentRow + 1
          tableData.push([
            {
              v: `${location.title}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${skill_level.title}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${splitNumberDigits((skill_level.debit / 100).toFixed(2))}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${splitNumberDigits((skill_level.aver_debit / 100).toFixed(2))}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${splitNumberDigits((skill_level.credit / 100).toFixed(2))}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${splitNumberDigits((skill_level.aver_credit / 100).toFixed(2))}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
          ])
        })
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData, ...footerRows])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Средний чек.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length
  return (
    <div>
      <ContentHeader title='Средний чек проверка' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>
      {pageState.isLoading ? (
        <Loader />
      ) : checkTableData?.locations[0]?.data.length ? (
        <>
          <div style={{ marginBottom: 20 }}>
            <ExportExcelButton
              data={[]}
              downloadExcel={() => {
                downloadExcel(checkTableData)
              }}
            />
          </div>
          <CheckReportTable
            firstLoad={pageState.firstLoad}
            checkTableData={checkTableData}
            online={online}
          />
        </>
      ) : (
        <h1 style={{ textAlign: 'center' }}>
          {pageState.firstLoad
            ? 'Сначала выберите параметры отчета'
            : 'Нет данных для отображения!'}
        </h1>
      )}
    </div>
  )
}

export default observer(AverageCheckReport)
